import { Props as AnswerProps } from '../..'

const Essay = ({ answer }: AnswerProps) => {
  return <div>{answer}</div>
}

export default Essay
